module.exports = __webpack_public_path__ + "img/logo.5d3427c6.jpeg";